<template>
  <div>
    <h3 class="pt-0 mt-0 pb-0">{{ $t("viewSettings.telephonies.title") }}</h3>
    <v-data-iterator
      :items="telephonies"
      row
      item-key="name"
      :options="{ itemsPerPage: 1000 }"
      wrap
      hide-default-footer
    >
      <template v-slot:default="{ items, isExpanded, expand }">
        <v-row>
          <v-col v-for="item in items" sm="12" md="6" lg="4" class="py-0">
            <v-card
              elevation="1"
              :loading="isSaving.includes(item.id)"
              :disabled="isSaving.includes(item.id)"
            >
              <v-toolbar
                @click="
                  () => {
                    expand(item, !isExpanded(item));
                  }
                "
                class="mt-2 pointer"
                elevation="0"
              >
                <template
                  v-if="
                    item.parameters &&
                    item.parameters[0].parameters.active === true
                  "
                >
                  <v-icon color="success" text-color="success" left
                    >fa-check-circle</v-icon
                  >
                </template>
                <template v-else>
                  <v-icon color="red" text-color="red" left
                    >fa-times-circle
                  </v-icon>
                </template>
                <v-toolbar-title>
                  <span>{{ item.name }}</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <div v-if="isExpanded(item)" mode="scale-transition">
                <v-form
                  lazy-validation
                  class="pa-2"
                  v-if="!item.nowSave"
                  :ref="'form' + item.name"
                >
                  <template v-for="(cfg, value) in item.available_parameters">
                    <template v-if="cfg && cfg.type === 'string'">
                      <v-text-field
                        :label="cfg.title"
                        :rules="[
                          (v) => {
                            if (v === 0) {
                              return true;
                            } else {
                              return (
                                !!v ||
                                $t('form.validationErrors.field_is_required')
                              );
                            }
                          },
                        ]"
                        required
                        v-model="item.parameters[0].parameters[cfg.name]"
                      ></v-text-field>
                    </template>
                    <template v-if="cfg && cfg.type === 'boolean'">
                      <v-switch
                        @change="saveTelephonyParameters(item)"
                        v-model="item.parameters[0].parameters[cfg.name]"
                        :label="cfg.title"
                      >
                      </v-switch>
                    </template>
                  </template>
                  <v-text-field
                    readonly
                    label="Webhook URL "
                    :value="getWebhookUrl(item)"
                    :ref="'url' + item.id"
                    append-icon="fa-copy"
                    @click:append="copyText('url' + item.id)"
                    @click="copyText('url' + item.id)"
                    aria-selected="true"
                  ></v-text-field>
                </v-form>
                <v-card-actions>
                  <v-btn
                    text
                    :disabled="item.nowSave"
                    @click="saveTelephonyParameters(item)"
                  >
                    {{ $t("common.save") }}
                  </v-btn>
                </v-card-actions>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </template>
    </v-data-iterator>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import router from "../../router";

export default {
  name: "TelephoniesComponent",
  data: () => ({
    isSaving: [],
  }),
  created() {
    this.onLoad();
  },
  computed: {
    ...mapFields("telephonies", ["telephonies"]),
    ...mapFields("auth", ["authenticatedUser"]),
  },
  watch: {
    $route(to, from) {
      this.onLoad();
    },
  },
  methods: {
    onLoad() {
      this.$store.dispatch("telephonies/get");
    },
    saveTelephonyParameters: function (data) {
      let formName = "form" + data.name;
      if (this.$refs[formName][0].validate()) {
        this.isSaving.push(data.id);
        this.$store.dispatch("telephonies/update", data).finally(() => {
          this.isSaving.splice(
            this.isSaving.findIndex((id) => parseInt(id) === parseInt(data.id)),
            1
          );
        });
      }
    },
    copyText(ref) {
      let textToCopy = this.$refs[ref][0].$el.querySelector("input");
      textToCopy.select();
      document.execCommand("copy");
    },
    getWebhookUrl(item) {
      return `${process.env.VUE_APP_TELEPHONY_WEBHOOK_URL}${this.authenticatedUser.shop.key}/${item.id}`;
    },
  },
};
</script>

<style scoped></style>
